import { OfferDetails } from './offer-details';

export default OfferDetails;
